<template>
  <div class="content">
    <p style="margin-bottom: 10px;">{{title}}</p>
    <el-form ref="schemeForm" :model="schemeForm" :rules="schemeRules"  label-width="100px">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span>方案信息</span>
        </div>
        <el-form-item label="方案名称" prop="name" style="width:60%">
            <el-input v-model="schemeForm.name" placeholder="方案名称"></el-input>
        </el-form-item>
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span style="color: #ff4949;margin-right: 4px;">*</span><span>套餐信息</span>
            <el-button style="margin-left:20px" type="primary" size="small" @click="handleAddProduct">添加</el-button>
        </div>
          <el-table :data="schemeForm.services"  max-height="400" border>
            <el-table-column prop="id" label="编号" align="center" width="100"></el-table-column>
            <el-table-column prop="productName" label="套餐名称" align="center" width="200" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="productType" label="套餐类型" align="center" width="138" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="flowCount" label="流量" align="center" width="100" ></el-table-column>
            <el-table-column prop="ledgerPrice" label="移动（元）" align="center">
              <template #default={row}>
                <el-input style="width: 100px;  color: red;" v-model="row.products[1].price"
                  oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="salePrice" label="电信（元）" align="center">
              <template #default={row}>
                <el-input style="width: 100px; color: red;" v-model="row.products[0].price"
                  oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="salePrice" label="联通（元）" align="center">
              <template #default={row}>
                <el-input style="width: 100px; color: red;" v-model="row.products[2].price"
                  oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template #default={row}>
                <el-button v-if="!!row.id" type="text" @click="deleteProduct(row)">移除套餐</el-button>
              </template>
            </el-table-column>
          </el-table>
      </el-card>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
            <span>
              <el-tooltip content="此方案划拨一批卡片" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
              卡片选择
            </span>
        </div>
        <el-form-item label="上传模式" prop="fieldType" >
          <el-radio-group v-model="schemeForm.fieldType" @input="switchFieldType">
            <el-radio  label="1" >批量ICCIDS</el-radio>
            <el-radio  label="2" >ICCID号段</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="ICCID列表" prop="iccids" v-if="schemeForm.fieldType == '1'">
          <el-input
            v-model="schemeForm.iccids"
            type="textarea"
            :placeholder="'以回车键分割ICCID\n'"
            rows="6"
            style="width:420px;font-size:14px"
            @input="handleCardSum"
          ></el-input>
        </el-form-item>
        <el-form-item label="ICCID范围" prop="startIccid" v-if="schemeForm.fieldType == '2'">
          <el-input
            v-model="schemeForm.startIccid"
            style="width: 230px;margin-right: 10px;"
            placeholder="包含开始值"
            clearable
            @paste.native="handlePaste"
          ></el-input>
          <span>-</span>
          <el-input
            v-model="schemeForm.endIccid"
            style="width: 230px;margin-left: 10px;"
            placeholder="包含终止值"
            clearable
            @paste.native="handlePaste"
          ></el-input>
          <el-button style="margin-left:10px" type="primary" @click="handleCardSum">统计</el-button>

        </el-form-item>
        <el-form-item>
          <span style="top: -2px;color: #666;">已选择<em style="color:red">{{number}}</em>条</span>
        </el-form-item>
      </el-card>
    </el-form>
    <div class="foot" v-if="!addProductOpen">
			<el-button type="primary" @click="submitScheme">保存方案</el-button>
		</div>
      <!--添加套餐-->
		<el-dialog title="添加套餐" :visible.sync="addProductOpen" width="1000px" append-to-body :close-on-click-modal="false">
			<el-form :model="productForm" ref="productForm" :inline="true">
				<el-form-item label="套餐名称">
					<el-input v-model="productForm.productName" placeholder="请输入套餐名称" clearable
						style="width: 200px;margin-right: 20px;" />
				</el-form-item>
				<el-form-item label="套餐类型">
					<el-select style="width:160px" v-model="productForm.productTypes" multiple filterable clearable placeholder="请选择">
						<el-option v-for="dict in productTypes" :key="dict.key" :label="dict.value"
							:value="dict.key">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="productDataPage">搜索</el-button>
				</el-form-item>
			</el-form>
      <div style="margin: 15px 0; color: #606266;">
          已选套餐：<span style="color: red;">{{ selectionProduct.length }}</span>个
      </div>
      <el-table :data="productData" height="500" @selection-change="handleSelectionProductChange">
        <el-table-column type="selection" align="center" width="60px"></el-table-column>
        <el-table-column prop="id" label="套餐编号" align="center"></el-table-column>
        <el-table-column prop="productName" label="套餐名称" align="center"></el-table-column>
        <el-table-column prop="productType" label="套餐类型" align="center" ></el-table-column>
        <el-table-column prop="flowCount" label="流量" align="center"></el-table-column>
        <el-table-column prop="showFlowCount" label="展示流量" align="center" ></el-table-column>
      </el-table>
      <pagination v-show="productTotal>0" :total="productTotal" :page-sizes="[10, 20, 30, 40]" :page-size="productForm.pageSize" :page.sync="productForm.page"
          :limit.sync="productForm.pageSize" @pagination="productDataPage" />
			<div class="dialog-footer" slot="footer">
				<el-button  type="primary" plain @click="confirmAddProduct">确定</el-button>
			</div>
		</el-dialog>
  </div>
</template>
<script>
import { agentDetail  , productPage ,selectCount , saveRatioScheme} from "@/api/api.js"; 
export default {
  name:'ratioSchemeAdd',
  data() {
    return {
      userId:this.$route.params.userId,
      title:'',
      number:0,
      schemeForm:{
        productName:undefined,
        userId:undefined,
        iccids:undefined,
        startIccid:undefined,
        endIccid:undefined,
        fieldType:'1',
        services:[]
      },
      schemeRules:{
        name: [
          { required: true, message: "请输入方案名称", trigger: "blur" },
        ],
      },
      agentList:[],
      addProductOpen:false,
      productForm:{
        productName:undefined,
        productTypes:[],
        type:'1',
        page:1,
        pageSize:10
      },
      productTotal:0,
      productTypes:[
        {key:'1',value:'累计套餐'},
        {key:'2',value:'月套餐'},
        {key:'3',value:'加油包'},
      ],
      productData:[],
      selectionProduct:[],
    };
  },
  methods: {
    // 获取数据
    initAgentDetail(){
      agentDetail({userId : this.userId}).then(res=>{
        let username = res.data.data.agent.username;
        let company = res.data.data.agent.companyName;
        this.title = "[" + username + "]" + company;
      });
    },
    productDataPage(){
      let productTypes = this.productForm.productTypes.length == 0?["1","2","3"] : this.productForm.productTypes
      let params = {
        model:{
          ...this.productForm,
          productTypes:productTypes
        },
        page: this.productForm.page,
        pageSize: this.productForm.pageSize,
      };
      productPage(params).then(res => {
        this.productData = res.data.data.records;
        this.productTotal = res.data.data.total;
        this.productData.forEach(item => {
          item.flowCount = this.formatFlow(item.flowCount);
          item.showFlowCount = this.formatFlow(item.showFlowCount);
          item.status = this.transferIsDisable(item.status);
        })
      });
    },
    handleAddProduct(){
      this.productDataPage()
      this.addProductOpen = true
    },
    handleSelectionProductChange(products){
      this.selectionProduct = products
    },
    confirmAddProduct(){
      this.addProductOpen = false
      let scs = this.schemeForm.services.map(m=>m.id)
      let products = this.selectionProduct.filter(item=>scs.indexOf(item.id) == -1)
      this.schemeForm.services.push(...products)
    },
    deleteProduct(row){
      let services = this.schemeForm.services;
      for (let i = services.length - 1; i >= 0; i--) {
        if (services[i].id === row.id) {
          services.splice(i, 1);
        }
      }
    },
    handleCardSum(){
      if(this.schemeForm.fieldType == '2'){
        if(!this.schemeForm.startIccid || !this.schemeForm.endIccid){
          this.number = 0
          return 
        }
        let startIccid = this.schemeForm.startIccid.replace(/\s+/g, '');
        let endIccid = this.schemeForm.endIccid.replace(/\s+/g, '');
        if(!startIccid || !endIccid){
          this.number = 0
          return 
        }
        selectCount({startIccid,endIccid}).then(res=>{
          this.number = res.data.data
        })
        return
      }
      let iccids = this.schemeForm.iccids ? this.schemeForm.iccids.split("\n"):[];
      this.number = iccids.filter(item=>!!item).length
    },
    submitScheme(){
      this.$refs.schemeForm.validate(valid=>{
        if (valid) {
          if(this.schemeForm.services.length == 0){
            this.$modal.msgError("请添加套餐");
            return 
          }
          let arrShow = true;
          let msg = "运营商价格不能小于0";
          this.schemeForm.services.forEach(item=>{
            item.products.forEach(product=>{
              if(!product.price || product.price <= 0){
                arrShow = false
                msg="运营商价格不能小于0";
                return 
              }
            })
          })
          if(!arrShow){
            this.$modal.msgError(msg);
            return 
          }else{
            if(this.number == 0){
              this.$modal.msgError("请输入ICCIDS或者输入ICCID范围");
              return 
            }
            //保存方案
            let params = {
              ...this.schemeForm,
              userId : this.userId,
              iccids:!!this.schemeForm.iccids ? this.schemeForm.iccids.split("\n") : []
            };
            saveRatioScheme(params).then(res=>{
              this.$message({type: 'success',message: '新建方案成功'});
              //关闭当前方案
              this.$store.dispatch('tagsView/delView', this.$route)
              this.$router.push('/agent/customProduct')
            })
          }
        }
      })
    },
    // 状态转换
    transferIsDisable(status) {
      let obj = {
        0: "未启用",
        1: "启用中"
      };
      return obj[status];
    },
    switchFieldType(label){
      this.handleCardSum()
      // if(label == '2'){
      //   this.number = 0
      // }
      // if(label == '1'){
      //   let iccids = this.schemeForm.iccids ? this.schemeForm.iccids.split("\n"):[];
      //   this.number = iccids.filter(item=>!!item).length
      // }

    },
    handlePaste(event){
      event.stopPropagation();
    },
    formatFlow(flow){
      if(!flow){
        return null;
      }
      if(0 > flow){
        flow = "畅享";
      }else if(1024 > flow > 0){
        flow = flow + 'M';
      }else if(flow >= 1024){
        flow = (flow/1024).toFixed(2) + 'G';
      }
      return flow;
    },
  },
  created() {
    this.initAgentDetail()
  }
};
</script>
<style scoped lang="less">
  .box-card {
    margin-bottom: 26px;
  }
  .foot {
		width: calc(100% - 210px);
		position: fixed;
		right: 0;
		bottom: 0;
		height: 60px;
		line-height: 60px;
		background-color: white;
		text-align: center;
		padding: 0 20px;
    z-index: 99999;
	}
</style>
